import { TranslatedText } from "@/components/common/text";
import { SadSmileIcon } from "@/components/common/svgs";
import { useIsDarkTheme } from "@/components/layout/useIsDarkTheme";
import { cn } from "@/utils/css";

export const NoSuggestionsContent = ({ className }) => {
    const isDarkTheme = useIsDarkTheme();
    return (
        <div
            className={cn("flex gap-2 flex-col justify-center items-center text-center w-full h-[218px] min-[1300px]:h-[140px]", className)}
        >
            <SadSmileIcon isDarkTheme={isDarkTheme} />
            <TranslatedText className="text-cm-p-text-primary text-sm/[22px]">No suggestions found for current selection</TranslatedText>
        </div>
    );
};
